import { useNavigationMenu } from '@/components/Menu/useNavigationMenu';
import Drawer from 'antd/es/drawer';
import Menu from 'antd/es/menu';
import { styled, useTheme } from 'styled-components';

const StyledDrawer = styled(Drawer)`
  ${({ theme }) => `
  .ant-drawer-body {
    padding: ${theme.padding}px 0;
  }
`}
`;

const StyledMenu = styled(Menu)`
  ${({ theme }) => `
  background: ${theme.colorBgElevated};
`}
`;

export const MobileMenuDrawer = ({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) => {
  const { items, selectedKeys } = useNavigationMenu({ mode: 'drawer' });
  const theme = useTheme();

  return (
    <StyledDrawer
      destroyOnHidden
      open={open}
      onClose={onClose}
      placement="left"
      width={theme.screenXS * 0.6}
    >
      <StyledMenu items={items} selectedKeys={selectedKeys} />
    </StyledDrawer>
  );
};
